/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as contentDetailReducer } from "./contentDetailSlice";
export { CONTENT_DETAIL_SEED_TYPE } from "./contentDetail.types";
export {
  // Async thunks
  loadContentDetail,
  loadContentDetailSheetData,
  createContentDetailRecording,
  prepareContentDetailRecording,
  playContentDetailAction,
  updateContentDetailFavorite,
  loadEpisodeGuideSeasons,
  loadEpisodeGuideSeasonPage,
  resolveNextEpisodeGuideSeason,
  loadUpcomingSection,
  loadUpcomingNextPage,
  loadMayAlsoLikeSection,
  loadMayAlsoLikeNextPage,
  captureContentDetailEntryScreen,
  logContentDetailViewedScreen,
  // Sync actions
  setActiveSeason,
  setFocusedRow,
  setFocusedActionIndex,
  setFocusedSection,
  setFocusedItemIndex,
  openContentDetailSheet,
  setSheetFocusedActionIndex,
  closeContentDetailSheet,
  contentDetailSheetErrorToast,
  resetContentDetailState,
  // Pagination constants (shared with the view's scroll threshold)
  EPISODE_GUIDE_PAGE_SIZE,
  UPCOMING_OFFERS_PAGE_SIZE,
  MORE_LIKE_THIS_PAGE_SIZE,
  PAGINATION_THRESHOLD,
  // Analytics
  CONTENT_DETAIL_SCREEN_ID,
  CONTENT_DETAIL_SCREEN_NAME,
  CONTENT_DETAIL_HIGHLIGHT_DWELL_MS,
  ContentDetailAnalyticsLogger,
  getContentDetailEntryScreenId,
  // Selectors
  selectContentDetailSeed,
  selectContentDetailKind,
  selectContentDetailIsLoading,
  selectContentDetailIsRefreshing,
  selectContentDetailError,
  selectContentDetailErrorCode,
  selectContentDetailTitle,
  selectContentDetailContentType,
  selectContentDetailRating,
  selectContentDetailStarRating,
  selectContentDetailReleaseYear,
  selectContentDetailDuration,
  selectContentDetailGenres,
  selectContentDetailDescription,
  selectContentDetailDescriptionMaxLines,
  selectContentDetailCast,
  selectContentDetailHeroImageUrl,
  selectContentDetailHeroImageAlt,
  selectContentDetailWatchActions,
  selectContentDetailStreamingServices,
  selectContentDetailUpcomingOfferText,
  selectContentDetailSchedule,
  selectContentDetailBadges,
  selectContentDetailNetworkLogoUrl,
  selectContentDetailNetworkName,
  selectContentDetailScheduleActions,
  selectContentDetailSections,
  selectEpisodeGuideObjectId,
  selectUpcomingObjectId,
  selectMayAlsoLikeObjectId,
  selectContentDetailEpisodeGuide,
  selectContentDetailUpcoming,
  selectContentDetailCastMembers,
  selectContentDetailMayAlsoLike,
  selectContentDetailFocusedRow,
  selectContentDetailFocusedActionIndex,
  selectContentDetailFocusedSectionIndex,
  selectContentDetailFocusedSectionArea,
  selectContentDetailFocusedItemIndex,
  selectContentDetailSheet
} from "./contentDetailSlice";
export type {
  ContentDetailActionData,
  ContentDetailActionIconKind,
  ContentDetailActionSubtitleData,
  ContentDetailBadgeData,
  ContentDetailCastData,
  ContentDetailEpisodeData,
  ContentDetailEpisodeGuideState,
  ContentDetailFocusedRow,
  ContentDetailKind,
  LoadContentDetailSheetParams,
  ContentDetailRecommendedData,
  ContentDetailSeasonData,
  ContentDetailSectionArea,
  ContentDetailSectionData,
  ContentDetailSectionId,
  ContentDetailSectionState,
  ContentDetailSectionStatus,
  ContentDetailSeed,
  ContentDetailSeedType,
  ContentDetailSheetState,
  ContentDetailState,
  ContentDetailStreamingServiceData,
  ContentDetailUpcomingData,
  ContentDetailUpcomingState
} from "./contentDetail.types";
export {
  getContentDetailSeriesRecordingId,
  getContentDetailFavoriteTarget,
  isContentDetailManageAction,
  isContentDetailWatchAction,
  readContentDetailActionString
} from "./contentDetailActions";
export {
  buildBadges,
  formatClockTime,
  formatDuration,
  formatEpisodeSubtitle,
  formatGenres,
  formatNextAiringText,
  formatSchedule,
  hasNoActions,
  mapContentScreenDetailsToState,
  mapUnifiedCollectionScreenDetailsToState,
  sanitizeCreditString
} from "./contentDetailMappers";
export {
  deriveUpcomingSeasons,
  formatOverlayLabel,
  formatShortDate,
  mapEpisode,
  mapMoreLikeThisItem,
  mapSeasons,
  mapUpcomingOffer
} from "./contentDetailSectionMappers";
export {
  formatNextAiring,
  formatSeasonEpisode,
  formatWatchOnProvider,
  getCastEmptyMessage,
  getContentTypeLabel,
  getEpisodesEmptyMessage,
  getLiveBadgeLabel,
  getMayAlsoLikeEmptyMessage,
  getNewBadgeLabel,
  getNoActionsAvailableMessage,
  getRetryLabel,
  getSectionErrorMessage,
  getSectionLabel,
  getSeasonLabel,
  getUpcomingEmptyMessage,
  getVideoResolutionLabel
} from "./contentDetailStrings";
export {
  CONTENT_DETAIL_ERROR_CODE,
  ContentDetailErrorMapper,
  getContentDetailErrorTitle,
  getContentDetailErrorDescription,
  getContentDetailSheetErrorMessage
} from "./contentDetailErrorMapper";
